import Icon from '@components/atoms/icon';
import { BodySmallRegular, H4 } from '@components/atoms/typography';

const MobileToolTab = ({ title, subtitle, onClick }) => (
  <div
    onClick={onClick}
    className="shadow rounded-lg px-6 py-5 flex justify-between pointer"
  >
    <div className="flex flex-col">
      <H4 className="mb-2">{title}</H4>
      <BodySmallRegular>{subtitle}</BodySmallRegular>
    </div>
    <div className="flex items-center">
      <Icon name="ArrowRight" className="w-6 h-6 text-neutral-800" />
    </div>
  </div>
);

export default MobileToolTab;
